export default "/images/mapping-img.svg?a32b800f640f8743da23d56138c03337";